import { initialContext } from '@auth0/auth0-react';

export const isLocalAuthBypassEnabled = ({
  nodeEnv = process.env.NODE_ENV,
  skipAuth = process.env.REACT_APP_SKIP_AUTH,
} = {}) => nodeEnv === 'development' && skipAuth === 'true';

export const createLocalAuthSession = ({
  nodeEnv = process.env.NODE_ENV,
  skipAuth = process.env.REACT_APP_SKIP_AUTH,
  token = process.env.REACT_APP_LOCAL_AUTH_TOKEN,
  email = process.env.REACT_APP_LOCAL_AUTH_EMAIL || 'local-dev@rely.business',
  name = process.env.REACT_APP_LOCAL_AUTH_NAME || 'Rely Local Dev',
} = {}) => {
  if (!isLocalAuthBypassEnabled({ nodeEnv, skipAuth })) {
    return null;
  }

  if (!token?.trim()) {
    throw new Error(
      'REACT_APP_LOCAL_AUTH_TOKEN is required when local auth bypass is enabled'
    );
  }

  const normalizedEmail = email.trim();

  return {
    ...initialContext,
    isAuthenticated: true,
    isLoading: false,
    user: {
      sub: `e2e|${normalizedEmail}`,
      email: normalizedEmail,
      email_verified: true,
      name: name.trim() || normalizedEmail,
    },
    getAccessTokenSilently: async () => token,
  };
};
